import { render, staticRenderFns } from "./ImgBox.vue?vue&type=template&id=e4ce2ef4"
import script from "./ImgBox.vue?vue&type=script&lang=ts"
export * from "./ImgBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports